module.exports = __webpack_public_path__ + "static/media/bg1.0d535fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/bg1.png
// module id = 1187
// module chunks = 0